import { ReportMonthDateRange } from './../../model/report-month-date-range';
import { DateHelperService } from './../../services/date-helper.service';

		
		import { BOLReportDTO } from './../../model/bol-report-dto';
    import { PartnerDto } from './../../model/partner-dto';
		import { PdfFileService } from './../../services/pdf-file.service';
		import { DatePipe } from '@angular/common';
		import { ExcelFileService } from './../../services/excel-file.service';
		import { FileExportService } from './../../services/file-export.service';
		import { ReportDateRangeDto } from './../../model/report-date-range-dto';
		import { HttpclientService } from './../../services/httpclient.service';
		import { AppSettingService } from './../../services/app-setting.service';
		import { Component, OnInit, TemplateRef } from '@angular/core';
		import * as moment from 'moment';
		import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
		import { ExceptionReportDto } from 'src/app/model/exception-report-dto';
		import { ModalModule, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-bol-report',
  templateUrl: './bol-report.component.html',
  styleUrls: ['./bol-report.component.css']
})
export class BOLReportComponent implements OnInit {
  daterange ;
  dateRange:string="";
  loading : boolean;
  bolReportArray : BOLReportDTO[];
  selectedBOLReportArray : BOLReportDTO[];
  bolReoprtListAllSelect  : BOLReportDTO[];
  selectedPartnerBOLReportArray : BOLReportDTO[];
  intialBOLReportList : BOLReportDTO[];
  partnerNameList : PartnerDto[];
  customerNameList : PartnerDto[];

  partnerModal : string;
  customerModal : string;
  selectedAllRow: boolean;

  bolReportListAllSelect  : BOLReportDTO[];

  maxDate: moment.Moment;

  count: number = 25;
  config: any;

  exportModal: string;
  exportList: string[] = ['Excel','PDF' ];
  selectedBOLReport: any = [];

  ispoDateSortCollapsedUpArrow: boolean;
  ispoDateSortCollapsedDownArrow: boolean;

  isbolCreatedDateSortCollapsedUpArrow: boolean;
  isbolCreatedDateSortCollapsedDownArrow: boolean;

  isaccountPayerNameSortCollapsedUpArrow: boolean;
  isaccountPayerNameSortCollapsedDownArrow: boolean;

  isdistributorPayerNameSortCollapsedUpArrow: boolean;
  isdistributorPayerNameSortCollapsedDownArrow: boolean;

  ispoStatusSortCollapsedUpArrow: boolean;
  ispoStatusSortCollapsedDownArrow: boolean;

  ispoNumberSortCollapsedUpArrow: boolean;
  ispoNumberSortCollapsedDownArrow: boolean;

  isbolNumberSortCollapsedUpArrow: boolean;
  isbolNumberSortCollapsedDownArrow: boolean;

  istotalShippedQuantitySortCollapsedUpArrow: boolean;
  istotalShippedQuantitySortCollapsedDownArrow: boolean;

  iszcraStatusSortCollapsedUpArrow: boolean;
  iszcraStatusSortCollapsedDownArrow: boolean;

  iszdraStatusSortCollapsedUpArrow: boolean;
  iszdraStatusSortCollapsedDownArrow: boolean;

  

  
  // sortArry: ExceptionReportDto[];
		  // sortArry1: BOLReportDTO[];
      constructor(private httpClient : HttpclientService,public appSettingService: AppSettingService,
        private pipe: PoOrderByPipe,public fileExportService: FileExportService,public pdfFileService: PdfFileService,
        public excelFileService: ExcelFileService,public datepipe: DatePipe
      ) { 
        this.bolReportArray = [];
        this.exportModal = this.exportList[0];
        this.config = {
          currentPage: 1,
          itemsPerPage: 25
        };
      }
  ngOnInit() {
    this.partnerModal ="-1";
    this.customerModal ="-1";
    this.getPartnersName();
    this.getCustomersName();
    this.maxDate = moment().add(0, 'days');
    this.exportModal = this.appSettingService.exportList[0];
  }


  getCustomersName(){
    this.loading=true;
    this.httpClient.getCustomersName().subscribe(
      data => {
        
        this.customerNameList=data;
        
        this.loading=false;
      }
    )
  }


  getPartnersName(){
    this.loading=true;
    this.httpClient.getPartnersName().subscribe(
      data => {
        
        this.partnerNameList=data;
        
        this.loading=false;
      }
    )
  }
		  
      getBOLReport(){
       var startDate = this.daterange.start.format('YYYY-MM-DD');
        var endDate = this.daterange.end.format('YYYY-MM-DD');
        this.loading=true;
        this.httpClient.getBOLReport(startDate, endDate).subscribe(
          data => {
            
            this.bolReportArray=data;
            this.intialBOLReportList=data;
            this.loading=false;
          }
        )
      } 

      initialSortValue() {
        this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
      }

      ChangeSortOrder(exportData) {
        this.exportModal = exportData;
      }

      onChangeSelectedCustomer(){
    
        if(this.customerModal!="-1" ){
          console.log(" customer > "+this.customerModal);
          this.partnerModal="-1";
          this.customerModal=this.customerModal;
          this.selectedPartnerBOLReportArray=[]; 
          var len = this.intialBOLReportList.length;
          var j =0;
          // this.customerModal = this.customerModal.toUpperCase();
          // const localCustomer  = this.customerModal;
          console.log("upper"+this.customerModal);
          
          for(let i = 0;i < len;i++) {
            if(this.customerModal === this.intialBOLReportList[i].editpid){
              this.selectedPartnerBOLReportArray[j] = this.intialBOLReportList[i]
              j++;
            }
          }
          this.bolReportArray = this.selectedPartnerBOLReportArray;
          }else if(this.customerModal === '-1'){
            this.bolReportArray = this.intialBOLReportList;
          }
        
      }

      changerecordperpage(value) {
    
        this.config.itemsPerPage = value;
        this.count = value;
      }
      modalPopup : boolean=false;
      modalPopupString: string;
      pressingOK(){
        this.modalPopup=false;
      }
      export() {
        if(this.bolReportArray == null || this.bolReportArray == undefined || this.bolReportArray.length === 0){
          this.modalPopupString="No Data to Export";
          this.modalPopup=true;
          return;
        }
        
        let flag : boolean;
       
        if (this.fileExportService.selectedBOLReportData.length === 0) {
          flag=true;
          this.bolReportListAllSelect = [];
          this.bolReportArray.forEach(bdto => {
            bdto.rowCheck = true;
            this.bolReportListAllSelect.push(bdto);
          });
          this.bolReportArray = this.bolReportListAllSelect;
          this.fileExportService.selectedBOLReportData = this.bolReportListAllSelect;
        } 
          if (this.exportModal === 'PDF') {
            this.pdfFileService.exportBOLReportTable('BOL Report Table');
          } else if (this.exportModal === 'Excel') {
            this.selectedBOLReport = [];
            this.fileExportService.selectedBOLReportData.forEach(bdto => {
              if (bdto.rowCheck) {
                var shippedQtyStr;
                if(bdto.poDate == null || bdto.poDate == ""  || bdto.poDate == undefined){
                  bdto.poDate="";
                }
                // else{
                //   bdto.poDate = this.datepipe.transform(bdto.poDate, this.appSettingService.globelDatePickerInUSAFormat);
                // }
                if(bdto.bolCreatedDate == null || bdto.bolCreatedDate == "" || bdto.bolCreatedDate == undefined){
                  bdto.bolCreatedDate="";
                }
                // else{
                //   bdto.bolCreatedDate = this.datepipe.transform(bdto.bolCreatedDate, this.appSettingService.globelDatePickerInUSAFormat) ;
                // }
                if(bdto.accountPayerName == null || bdto.accountPayerName == "" || bdto.accountPayerName == undefined){
                  bdto.accountPayerName="";
                }
                if(bdto.distributorPayerName == null || bdto.distributorPayerName == "" || bdto.distributorPayerName == undefined){
                  bdto.distributorPayerName="";
                }
                if(bdto.poStatus == null || bdto.poStatus == "" || bdto.poStatus == undefined){
                  bdto.poStatus="";
                }
                if(bdto.poNumber == null || bdto.poNumber == "" || bdto.poNumber == undefined){
                  bdto.poNumber="";
                }
                if(bdto.bolNumber == null || bdto.bolNumber == "" || bdto.bolNumber == undefined){
                  bdto.bolNumber="";
                }
                if(bdto.totalShippedQty == null||bdto.totalShippedQty == undefined){
                  bdto.totalShippedQty="";
                }
                if(bdto.zcraStatus == null || bdto.zcraStatus == "" || bdto.zcraStatus == undefined){
                  bdto.zcraStatus = "";
                }
                if(bdto.zdraStatus == null || bdto.zdraStatus == "" || bdto.zdraStatus == undefined){
                  bdto.zdraStatus = "";
                }            
    
                this.selectedBOLReport.push({
                  'PO Date': `` + `${bdto.poDate}`,'BOL Created Date': `` + `${bdto.bolCreatedDate}`,'Account Payer Name': `${bdto.accountPayerName}`,
                  'Distributor Payer Name ': `${bdto.distributorPayerName }`,'PO Status': `${bdto.poStatus}`, 'PO Number': `${bdto.poNumber}`, 'BOL Number': `${bdto.bolNumber}`,
                  'Total Shipped Quantity': `${bdto.totalShippedQty}`, 'ZDRA Status':  `${bdto.zdraStatus}`,
                  'ZCRA Status': `${bdto.zcraStatus}`, 
                });
              }
            });
            this.excelFileService.exportBOLReportTableExcel(this.selectedBOLReport, 'BOL Report Table');
          }
          if(flag){
            this.bolReportListAllSelect = [];
            this.bolReportArray.forEach(pdto => {
              pdto.rowCheck = false;
              this.bolReportListAllSelect.push(pdto);
            });
            this.bolReportArray = this.bolReportListAllSelect;
            this.fileExportService.selectedBOLReportData = [];
          }
      }
      pageChanged(event) {
        this.config.currentPage = event;
      }
      onSelect(selectedItem: any, values: any) {
        let checkStaus = true;
        if (values.currentTarget.checked) {
    
          this.fileExportService.selectedBOLReportData.push(selectedItem);
        } else if (!values.currentTarget.checked) {
    
          this.fileExportService.selectedBOLReportData = this.fileExportService.selectedBOLReportData.filter(obj => obj !== selectedItem);
         
        }
    
        if(this.fileExportService.selectedBOLReportData.length === this.bolReoprtListAllSelect.length){
          this.selectedAllRow = true;
        }else{ 
          this.selectedAllRow = false;
        }
        
    
    }

    sortArry : BOLReportDTO[];
    onChangeSort(event: any, upDown: boolean, propertyName: string) {
      this.intialBOLReportList=this.bolReportArray;
      if (propertyName === 'poDate' ) {
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
       if (upDown) {
     this.sortArry = [];
     this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, upDown);
     this.bolReportArray = [];
     this.bolReportArray = this.sortArry;
     this.ispoDateSortCollapsedUpArrow = !this.ispoDateSortCollapsedUpArrow;
     this.ispoDateSortCollapsedDownArrow = true;
  } else {
   this.sortArry = [];
   this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, upDown);
   this.bolReportArray = [];
   this.bolReportArray = this.sortArry;
   this.ispoDateSortCollapsedDownArrow = !this.ispoDateSortCollapsedDownArrow;
   this.ispoDateSortCollapsedUpArrow = true;
  }
   } 
      else if (propertyName === 'bolCreatedDate' ) {
        this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, upDown);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.isbolCreatedDateSortCollapsedUpArrow = !this.isbolCreatedDateSortCollapsedUpArrow;
      this.isbolCreatedDateSortCollapsedDownArrow = true;
  } else {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, upDown);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.isbolCreatedDateSortCollapsedDownArrow = !this.isbolCreatedDateSortCollapsedDownArrow;
    this.isbolCreatedDateSortCollapsedUpArrow = true;
  }
    } else if (propertyName === 'accountPayerName' ) {
      this.ispoDateSortCollapsedUpArrow=true;
      this.ispoDateSortCollapsedDownArrow=true;
      this.isbolCreatedDateSortCollapsedUpArrow=true;
      this.isbolCreatedDateSortCollapsedDownArrow=true;
      this.isdistributorPayerNameSortCollapsedUpArrow=true;
      this.isdistributorPayerNameSortCollapsedDownArrow= true;
      this.ispoStatusSortCollapsedUpArrow= true;
      this.ispoStatusSortCollapsedDownArrow= true;
      this.ispoNumberSortCollapsedUpArrow=true;
      this.ispoNumberSortCollapsedDownArrow=true;
      this.isbolNumberSortCollapsedUpArrow= true;
      this.isbolNumberSortCollapsedDownArrow= true;
      this.istotalShippedQuantitySortCollapsedUpArrow= true;
      this.istotalShippedQuantitySortCollapsedDownArrow= true;
      this.iszcraStatusSortCollapsedUpArrow= true;
      this.iszcraStatusSortCollapsedDownArrow= true;
      this.iszdraStatusSortCollapsedUpArrow= true;
      this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.isaccountPayerNameSortCollapsedUpArrow = !this.isaccountPayerNameSortCollapsedUpArrow;
      this.isaccountPayerNameSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.isaccountPayerNameSortCollapsedDownArrow = !this.isaccountPayerNameSortCollapsedDownArrow;
    this.isaccountPayerNameSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'distributorPayerName' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.isdistributorPayerNameSortCollapsedUpArrow = !this.isdistributorPayerNameSortCollapsedUpArrow;
      this.isdistributorPayerNameSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.isdistributorPayerNameSortCollapsedDownArrow = !this.isdistributorPayerNameSortCollapsedDownArrow;
    this.isdistributorPayerNameSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'poStatus' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.ispoStatusSortCollapsedUpArrow = !this.ispoStatusSortCollapsedUpArrow;
      this.ispoStatusSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.ispoStatusSortCollapsedDownArrow = !this.ispoStatusSortCollapsedDownArrow;
    this.ispoStatusSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'poNumber' ) {
      this.ispoDateSortCollapsedUpArrow=true;
      this.ispoDateSortCollapsedDownArrow=true;
      this.isbolCreatedDateSortCollapsedUpArrow=true;
      this.isbolCreatedDateSortCollapsedDownArrow=true;
      this.isaccountPayerNameSortCollapsedUpArrow= true;
      this.isaccountPayerNameSortCollapsedDownArrow= true;
      this.isdistributorPayerNameSortCollapsedUpArrow=true;
      this.isdistributorPayerNameSortCollapsedDownArrow= true;
      this.ispoStatusSortCollapsedUpArrow= true;
      this.ispoStatusSortCollapsedDownArrow= true;
      this.isbolNumberSortCollapsedUpArrow= true;
      this.isbolNumberSortCollapsedDownArrow= true;
      this.istotalShippedQuantitySortCollapsedUpArrow= true;
      this.istotalShippedQuantitySortCollapsedDownArrow= true;
      this.iszcraStatusSortCollapsedUpArrow= true;
      this.iszcraStatusSortCollapsedDownArrow= true;
      this.iszdraStatusSortCollapsedUpArrow= true;
      this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      console.log("property"+propertyName);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.ispoNumberSortCollapsedUpArrow = !this.ispoNumberSortCollapsedUpArrow;
      this.ispoNumberSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.ispoNumberSortCollapsedDownArrow = !this.ispoNumberSortCollapsedDownArrow;
    this.ispoNumberSortCollapsedUpArrow = true;
  } 
  } else if (propertyName === 'bolNumber' ) {
    this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
        this.iszdraStatusSortCollapsedUpArrow= true;
        this.iszdraStatusSortCollapsedDownArrow= true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
    console.log("property"+propertyName);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.isbolNumberSortCollapsedUpArrow = !this.isbolNumberSortCollapsedUpArrow;
    this.isbolNumberSortCollapsedDownArrow = true;
  } else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
  this.bolReportArray = [];
  this.bolReportArray = this.sortArry;
  this.isbolNumberSortCollapsedDownArrow = !this.isbolNumberSortCollapsedDownArrow;
  this.isbolNumberSortCollapsedUpArrow = true;
  }
  } else if (propertyName === 'totalShippedQty' ) {
    this.ispoDateSortCollapsedUpArrow=true;
    this.ispoDateSortCollapsedDownArrow=true;
    this.isbolCreatedDateSortCollapsedUpArrow=true;
    this.isbolCreatedDateSortCollapsedDownArrow=true;
    this.isaccountPayerNameSortCollapsedUpArrow= true;
    this.isaccountPayerNameSortCollapsedDownArrow= true;
    this.isdistributorPayerNameSortCollapsedUpArrow=true;
    this.isdistributorPayerNameSortCollapsedDownArrow= true;
    this.ispoStatusSortCollapsedUpArrow= true;
    this.ispoStatusSortCollapsedDownArrow= true;
    this.ispoNumberSortCollapsedUpArrow=true;
    this.ispoNumberSortCollapsedDownArrow=true;
    this.isbolNumberSortCollapsedUpArrow= true;
    this.isbolNumberSortCollapsedDownArrow= true;
    this.iszcraStatusSortCollapsedUpArrow= true;
    this.iszcraStatusSortCollapsedDownArrow= true;
    this.iszdraStatusSortCollapsedUpArrow= true;
    this.iszdraStatusSortCollapsedDownArrow= true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
    console.log("property"+propertyName);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.istotalShippedQuantitySortCollapsedUpArrow = !this.istotalShippedQuantitySortCollapsedUpArrow;
    this.istotalShippedQuantitySortCollapsedDownArrow = true;
  } else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
  this.bolReportArray = [];
  this.bolReportArray = this.sortArry;
  this.istotalShippedQuantitySortCollapsedDownArrow = !this.istotalShippedQuantitySortCollapsedDownArrow;
  this.istotalShippedQuantitySortCollapsedUpArrow = true;
  } 
     } else if (propertyName === 'zcraStatus' ) {
      this.ispoDateSortCollapsedUpArrow=true;
      this.ispoDateSortCollapsedDownArrow=true;
      this.isbolCreatedDateSortCollapsedUpArrow=true;
      this.isbolCreatedDateSortCollapsedDownArrow=true;
      this.isaccountPayerNameSortCollapsedUpArrow= true;
      this.isaccountPayerNameSortCollapsedDownArrow= true;
      this.isdistributorPayerNameSortCollapsedUpArrow=true;
      this.isdistributorPayerNameSortCollapsedDownArrow= true;
      this.ispoStatusSortCollapsedUpArrow= true;
      this.ispoStatusSortCollapsedDownArrow= true;
      this.ispoNumberSortCollapsedUpArrow=true;
      this.ispoNumberSortCollapsedDownArrow=true;
      this.isbolNumberSortCollapsedUpArrow= true;
      this.isbolNumberSortCollapsedDownArrow= true;
      this.istotalShippedQuantitySortCollapsedUpArrow= true;
      this.istotalShippedQuantitySortCollapsedDownArrow= true;
      this.iszdraStatusSortCollapsedUpArrow= true;
      this.iszdraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      console.log("property"+propertyName);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.iszcraStatusSortCollapsedUpArrow = !this.iszcraStatusSortCollapsedUpArrow;
      this.iszcraStatusSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.iszcraStatusSortCollapsedDownArrow = !this.iszcraStatusSortCollapsedDownArrow;
    this.iszcraStatusSortCollapsedUpArrow = true;
  } 
    } else if (propertyName === 'zdraStatus' ) {
      this.ispoDateSortCollapsedUpArrow=true;
        this.ispoDateSortCollapsedDownArrow=true;
        this.isbolCreatedDateSortCollapsedUpArrow=true;
        this.isbolCreatedDateSortCollapsedDownArrow=true;
        this.isaccountPayerNameSortCollapsedUpArrow= true;
        this.isaccountPayerNameSortCollapsedDownArrow= true;
        this.isdistributorPayerNameSortCollapsedUpArrow=true;
        this.isdistributorPayerNameSortCollapsedDownArrow= true;
        this.ispoStatusSortCollapsedUpArrow= true;
        this.ispoStatusSortCollapsedDownArrow= true;
        this.ispoNumberSortCollapsedUpArrow=true;
        this.ispoNumberSortCollapsedDownArrow=true;
        this.isbolNumberSortCollapsedUpArrow= true;
        this.isbolNumberSortCollapsedDownArrow= true;
        this.istotalShippedQuantitySortCollapsedUpArrow= true;
        this.istotalShippedQuantitySortCollapsedDownArrow= true;
        this.iszcraStatusSortCollapsedUpArrow= true;
        this.iszcraStatusSortCollapsedDownArrow= true;
      if (upDown) {
      this.sortArry = [];
      this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, true);
      console.log("property"+propertyName);
      this.bolReportArray = [];
      this.bolReportArray = this.sortArry;
      this.iszdraStatusSortCollapsedUpArrow = !this.iszdraStatusSortCollapsedUpArrow;
      this.iszdraStatusSortCollapsedDownArrow = true;
  } else {
    this.sortArry = []; 
    this.sortArry = this.pipe.transform(this.intialBOLReportList, propertyName, false);
    this.bolReportArray = [];
    this.bolReportArray = this.sortArry;
    this.iszdraStatusSortCollapsedDownArrow = !this.iszdraStatusSortCollapsedDownArrow;
    this.iszdraStatusSortCollapsedUpArrow = true;
  } 
    } 
   
  }
}
